import React from "react";

import { Card, CardBody, CardHeader, Button, Alert } from "reactstrap";

import AccessLinkWarningAlert from "./AccessLinkWarningAlert";

const StartCard = (props) => {
  const { email, accessKey, onNextStep } = props;

  return (
    <Card>
      <AccessLinkWarningAlert email={email} />
      <CardHeader>
        <span>Request your sample plan</span>
      </CardHeader>
      <CardBody>
        <p className="mb-2">
          A sample plan is a great way to see how our plans work and what kind
          of food you'll be eating.
        </p>
        <p className="mb-2">
          To make sure we personalize your plan exactly for your tastes and body
          type, we need some information about your preferences.
        </p>

        <br />
        <center>
          <Button size="lg" color="primary" onClick={onNextStep}>
            Get Started
          </Button>
        </center>
      </CardBody>
    </Card>
  );
};

export default StartCard;
